/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import BooleanInput from 'app/common/components/BooleanInput';

const defaultProps = {
  disabled: false,
};

const Styles = {
  root: css`
    display: flex;
    align-items: center;
  `,
  label: css`
    margin-left: 10px;
  `,
};

type Field = {
  key: string;
  disabled: boolean;
  value: string;
  checkboxLabel: string;
};

type Props = Field & {
  field?: Field;
  onChange: (isChecked: boolean, config?: { field: {} }) => void;
};

/**
 * A single checkbox that supports having a field label as well as a checkbox label. A similar component
 * <CheckboxField /> adds its own Formatic like labels. This component works with Formatic to appear as other
 * components found in that library.
 * Intended to be used with Formatic and wrapWithFormaticField, but could be used as a standalone checkbox.
 */
const SingleCheckboxField = (props: Props) => {
  const source = props.field || props;
  return (
    <label css={Styles.root}>
      <BooleanInput
        checked={source.value}
        disabled={source.disabled}
        hasExternalLabel={true}
        name={source.key}
        onChangeValue={isChecked => {
          props.onChange(isChecked, { field: source });
        }}
        type="checkbox"
        value={source.key}
      />
      <span css={Styles.label}>{source.checkboxLabel}</span>
    </label>
  );
};

SingleCheckboxField.defaultProps = defaultProps;

export default SingleCheckboxField;
